import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { FormFieldDropdown } from '~/components/FormField';
import { useDistributorList } from '~settings/api/queries/distributorList';
import { toDropdownList } from '~settings/utils/transformers';

interface SelectDistributorProps
  extends Omit<
      ComponentProps<typeof FormFieldDropdown>,
      'clientSearch' | 'label' | 'options' | 'onSearchChange' | 'search'
    >,
    Partial<Pick<ComponentProps<typeof FormFieldDropdown>, 'label'>> {}

export function SelectDistributor(props: SelectDistributorProps) {
  const { t } = useTranslation('settings', {
    keyPrefix: 'dropdowns.distributors',
  });

  const { isLoading, distributorList } = useDistributorList();

  const distributors = distributorList?.data ?? [];

  return (
    <FormFieldDropdown
      label={t('title')}
      placeholder={t('placeholder')}
      {...props}
      options={toDropdownList(
        distributors,
        (item) => `${item.us} (US) + ${item.exUs} (ex-US)`,
      )}
      readOnly={isLoading || props.readOnly}
      noOptionsText={t('noOptions')}
    />
  );
}
SelectDistributor.displayName = 'SelectDistributor';
